import { render, staticRenderFns } from "./PersonalView.vue?vue&type=template&id=16bb2125"
import script from "./PersonalView.vue?vue&type=script&lang=js"
export * from "./PersonalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports